<template>
  <div class="com-part1">
	  <title1 type="1" title="服务器概览" style="margin-top: 30px" />
    <!-- <MyTitle title="服务器概览" subTitle="" /> -->
    <!-- <div class="sub-title flex justify-end align-center">
            <div
                v-for="(item, i) in subTitle" :key="'subTitle' + i"
                @click="subTitleChange(i)">
                <p :class="{'at': i == subTitleAt}">{{ item.label }}</p>
            </div>
        </div>
        <div v-if="showaa" class="p-content flex align-center">

        </div> -->
    <div v-if="showNum" class="p-content flex align-center mt-50">
      <img
        class="img flexs"
        :src="require('@/assets/images/computility/dispatch-icon4.png')"
        alt=""
      />
      <div class="i-list flex flex1">
        <div
          class="list-all flex flex-direction align-center justify-center flexs"
        >
          <div class="flex align-items-flex-end">
            <!-- <dv-digital-flop
              style="height: 80px; width: 100%"
              :config="dvDigitalFlopConfig(allNum)"
            /> -->
            <animate-number class="number" from="0" :to="allNum.value" :key="allNum.value" duration="2000"></animate-number>
            <span style="font-size: 30px">台</span>
          </div>
          <div class="fs-24 mt-10">总数</div>
        </div>
        <div class="flex1 flex flex-direction justify-center">
          <div
            v-for="(item, i) in list"
            :key="'list' + i"
            class="item flex align-center"
          >
            <div class="item-l flexs" :style="{ background: item.color }"></div>
            <div class="item-c flexs" :style="{ color: item.color }">
              {{ item.label }}
            </div>
            <div class="item-r flex1">
              <!-- <dv-digital-flop
                style="height: 30px; width: 100%"
                :config="dvDigitalFlopConfig(item)"
              /> -->
              <animate-number class="num" :style="{color: item.color}" from="0" :to="item.value" :key="item.value" duration="2000"></animate-number>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
	title1
  },
  data() {
    return {
      subTitle: [
        {
          label: "服务器",
        },
        {
          label: "节点",
        },
      ],
      subTitleAt: 0,
      showaa: false,
      allNum: {
        value: 75,
        fontSize: 90,
      },
      list: [
        {
          label: "运行中",
          value: "75",
          color: "#28C89A",
          textAlign: "left",
        },
        {
          label: "关机",
          value: "0",
          color: "#FFFFFF",
          textAlign: "left",
        },
        {
          label: "其他",
          value: "0",
          color: "#FFD15C",
          textAlign: "left",
        },
      ],
      showNum: false,
    };
  },
  mounted() {
    this.getData();
  },
  created() {},
  methods: {
    // 字体动态
    dvDigitalFlopConfig(item = {}) {
      let counts = parseFloat(item.value || 0);
      console.log(counts, "字体动态");
      let config = {
        number: [parseFloat(counts)],
        textAlign: item.textAlign || "center",
        style: {
          fill: item.color || "#fff",
          fontSize: item.fontSize || 32,
          fontFamily: "DS-Digital-Bold",
        },
      };
      console.log("==config==", config);
      return config;
    },
    // 副标题切换
    subTitleChange(i) {
      this.subTitleAt = i;
    },
    async getData() {
      let params = {
        enCode: "computingpower-left-fwqgl",
      };
      // dataInterface.dataFaceApi(params).then(res => {
      // 	console.log(res, '服务器概览11')
      //     let data = res[0] || {}
      //     this.allNum.value = data.hostNum || 0
      //     this.list[0].value = data.startNum || 0
      //     this.list[1].value = data.stopNum || 0
      //     this.list[2].value = data.otherNum || 0

      // })

      const res = await dataInterface.dataFaceApi(params);
      let data = res[0] || {};
      this.allNum.value = data.hostNum || 0;
      this.list[0].value = data.startNum || 0;
      this.list[1].value = data.stopNum || 0;
      this.list[2].value = data.otherNum || 0;
      this.showNum = true;
      this.$set(this.list);
      console.log(this.allNum.value, this.list, "服务器概览333");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../comm.scss";

.number{
    font-size: 80px;
    line-height: 70px;
    @include ffamily-DS;
}

.num{
    font-size: 40px;
    // line-height: 70px;
    @include ffamily-DS;
}
.com-part1 {
  width: 100%;
  height: 566px;
  .sub-title {
    font-size: $FontSize28;
    // padding-top:60px;
    padding: 60px 0 40px 0;
    height: 50px;
    > div {
      padding-right: 20px;
      > p {
        text-shadow: 0px 0px 9px #03b9bd;
        padding: 0 10px;
        position: relative;
        cursor: pointer;
        &.at {
          &::after {
            position: absolute;
            bottom: -10px;
            left: 0;
            content: "";
            width: 100%;
            height: 2px;
            background: linear-gradient(
              270deg,
              rgba(113, 186, 188, 0.0001) 0%,
              #71bbbd 33.33%,
              #6db5b7 66.67%,
              rgba(111, 185, 187, 0.0001) 100%
            );
          }
        }
      }
    }
  }
  .p-content {
    width: 100%;
    height: 300px;
    .img {
      width: 270px;
      height: 208px;
      margin: 0 20px;
      // background-color: red;
    }
    .i-list {
      width: 100%;
      // padding:0 160px;
      justify-content: space-around;
      .list-all {
        width: 180px;
      }
      .item {
        font-size: $FontSize20;
        // padding: 10px 0;
        padding-left: 68px;
        height: 80px;
        .item-l {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .item-c {
          width: 100px;
          font-size: 30px;
        }
      }
    }
  }
}
.img {
  animation: breath_light 3s ease infinite;
}
</style>